import { integrationLinksList } from "@/app/Settings/Settings/GraphQL/integrationLinksQueries";
import {
  useGqlMutation,
  useSuspenseGqlQuery,
} from "@/lib/GraphQLCodegen/fetcher";
import { CellContext } from "@/lib/Components/DataTable/types";
import { VehicleListItem } from "@/app/Vehicles/GraphQL/vehicleListQuery";
import { ModelType } from "@/gql/graphql";
import { useIntegrationRecord } from "@/app/Settings/Settings/Hooks/useIntegrationRecord";
import { useJucyVehicleCodesList } from "@/app/Settings/Integrations/Jucy/Hooks/useJucyCodesList";
import { Suspense, useState } from "react";
import { upsertIntegrationLink } from "@/app/Settings/Settings/GraphQL/integrationLinkMutations";
import { QueryClient } from "@/lib/ReactQuery/QueryClient";
import { Select } from "@/components/catalyst/select";
import { Skeleton } from "@/components/ui/skeleton";

export function JucyVehicleCodeCell(props: CellContext<VehicleListItem, any>) {
  return (
    <Suspense fallback={<Skeleton className="h-9 w-[356px]" />}>
      <CellInner {...props} />
    </Suspense>
  );
}

function CellInner({ row }: CellContext<VehicleListItem, any>) {
  const jucyIntegration = useIntegrationRecord();

  const integrationLinks = useSuspenseGqlQuery(integrationLinksList, {
    integration_id: jucyIntegration.id,
  });

  const integrationLink = integrationLinks.data?.integrationLinks.data.find(
    (item) => {
      return (
        item.object_type === ModelType.Vehicle &&
        item.object_id === row.original.id
      );
    },
  );

  const { data } = useJucyVehicleCodesList();

  const externalIds =
    data
      ?.filter((vehicle) => {
        return vehicle.region === jucyIntegration.metadata.region;
      })
      .map((vehicle) => {
        return {
          label: `${vehicle.name} (${vehicle.code})`,
          value: vehicle.code,
        };
      }) ?? [];

  const [externalId, setExternalId] = useState<string>(
    integrationLink?.external_id ?? "",
  );

  const { mutateAsync } = useGqlMutation(upsertIntegrationLink, {
    onSuccess: () => {
      return QueryClient.invalidateQueries();
    },
  });

  return (
    <Select
      value={externalId}
      onChange={async (e) => {
        setExternalId(e.target.value);
        await mutateAsync({
          id: integrationLink?.id,
          input: {
            external_id: e.target.value,
            object: {
              connect: {
                id: row.original.id,
                type: ModelType.Vehicle,
              },
            },
            integration: {
              connect: jucyIntegration.id,
            },
          },
        });
      }}
    >
      <option value="" disabled>
        Select a vehicle
      </option>
      {externalIds.map((externalId) => (
        <option key={externalId.value} value={externalId.value}>
          {externalId.label}
        </option>
      ))}
    </Select>
  );
}
